"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _Tooltip = _interopRequireDefault(require("../../common/Tooltip/Tooltip"));
var _ProgressBar = require("../../common/ProgressBar/ProgressBar");
var _AccountSummaryBox = require("./AccountSummaryBox");
require("./AccountSummaryComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('wallets-account-summary');
var FuturesAccountSummaryComponent = function FuturesAccountSummaryComponent(_ref) {
  var _summary$TotalBalance, _summary$MarginBalanc, _summary$UsableMargin, _summary$UnrealizedPr, _summary$ProfitAndLos, _summary$InitialMargi, _summary$InitialMargi2, _summary$MaintenanceM, _summary$MaintenanceM2;
  var baseAsset = _ref.baseAsset,
    summary = _ref.summary;
  var _useTranslation = (0, _reactI18next.useTranslation)('futures'),
    t = _useTranslation.t;
  var formatValue = function formatValue(value) {
    return isNaN(value) || value === undefined ? value : (0, _numberFormatter.formatNumberToLocale)(value, baseAsset.DecimalPlaces);
  };
  var formatPercent = function formatPercent(value) {
    var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    return isNaN(value) || value === undefined || value === 0 ? '-' : "".concat((0, _numberFormatter.formatNumberToLocale)(value, decimalPlaces), "%");
  };
  var baseAssetSymbol = baseAsset.Product;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('component', ['futures'])
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('left-section')
  }, /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t('Total Balance ({{asset}})', {
      asset: baseAssetSymbol
    }),
    value: formatValue((_summary$TotalBalance = summary.TotalBalanceNotional) !== null && _summary$TotalBalance !== void 0 ? _summary$TotalBalance : '-'),
    labelTooltip: t('Combined value of all your assets in your Futures account. Balances are displayed in the default currency based on current market prices.')
  }), /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t('Margin Balance ({{asset}})', {
      asset: baseAssetSymbol
    }),
    value: formatValue((_summary$MarginBalanc = summary.MarginBalanceNotional) !== null && _summary$MarginBalanc !== void 0 ? _summary$MarginBalanc : '-'),
    labelTooltip: t('Total funds in your futures account used as collateral for leveraged positions. Includes: Futures Total Balance + Unrealized P&L.')
  }), /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t('Usable Margin ({{asset}})', {
      asset: baseAssetSymbol
    }),
    value: formatValue((_summary$UsableMargin = summary.UsableMarginNotional) !== null && _summary$UsableMargin !== void 0 ? _summary$UsableMargin : '-'),
    labelTooltip: t('Available funds in your futures account to initiate new trades or to add more margin to your existing positions.')
  }), /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t('Unrealized P&L'),
    value: formatPercent(summary.UnrealizedProfitAndLossPercentage, 2),
    labelTooltip: t('Indicates the current, collective "paper" profit or loss of all your open futures positions combined.')
  }, formatValue((_summary$UnrealizedPr = summary.UnrealizedProfitAndLossNotional) !== null && _summary$UnrealizedPr !== void 0 ? _summary$UnrealizedPr : '-'), " ", baseAssetSymbol), /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t("Today's P&L"),
    value: formatPercent(summary.ProfitAndLossPercentage, 2),
    labelTooltip: t('Account’s total profit or loss for the current trading day, calculated as the difference between the value of your assets at the start of the day and their current value. This calculation includes realized profits or losses from closed positions and unrealized changes from open positions and nets any possible transfer.')
  }, formatValue((_summary$ProfitAndLos = summary.ProfitAndLossNotional) !== null && _summary$ProfitAndLos !== void 0 ? _summary$ProfitAndLos : '-'), " ", baseAssetSymbol)), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('right-section')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "progress-bar-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "progress-label-text"
  }, t('IM')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "progress-bar-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_ProgressBar.ProgressBar, {
    percentage: (_summary$InitialMargi = summary.InitialMarginPercentage) !== null && _summary$InitialMargi !== void 0 ? _summary$InitialMargi : '-',
    tooltip: t("Percentage of positions' value reserved from your balance upon opening positions.")
  })), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    text: t("Portion of positions' value in Base Asset reserved from your balance upon opening positions.")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "notional-label "
  }, formatValue((_summary$InitialMargi2 = summary.InitialMarginNotional) !== null && _summary$InitialMargi2 !== void 0 ? _summary$InitialMargi2 : '-'), " ", baseAssetSymbol))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "progress-bar-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "progress-label-text"
  }, t('MM')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "progress-bar-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_ProgressBar.ProgressBar, {
    percentage: (_summary$MaintenanceM = summary.MaintenanceMarginPercentage) !== null && _summary$MaintenanceM !== void 0 ? _summary$MaintenanceM : '-',
    tooltip: t("Percentage of positions' value required in your futures balance to maintain positions open and avoid liquidation.")
  })), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    text: t("Portion of positions' value in Base Asset required in your futures balance to maintain positions open and avoid liquidation.")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "notional-label"
  }, formatValue((_summary$MaintenanceM2 = summary.MaintenanceMarginNotional) !== null && _summary$MaintenanceM2 !== void 0 ? _summary$MaintenanceM2 : '-'), " ", baseAssetSymbol)))));
};
var _default = exports["default"] = FuturesAccountSummaryComponent;